import { render, staticRenderFns } from "./DetailIklan.vue?vue&type=template&id=ea5b5558"
import script from "./DetailIklan.vue?vue&type=script&lang=js"
export * from "./DetailIklan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports